const en = {
  nav: {
    home: "Home",
    product: "Product",
    QA: "Q&A",
    explore: "Explore",
    login: "Login",
    register: "Register",
    registerNow: "Register",
    demoStore: 'Demo Store',
    slideTitle: "Global Acquiring",
    slideTitleSplit: "Access to <br/>5 billion consumers",
    slideChoiceTitle: "Choice of Value",
    slideBrandTitle: "Trusted by industry leaders",
    footerAgreement: "Merchant Service Agreement",
    email: "Contact",
    back: "Return",
  },
  feature: {
    coverage: "Global Coverage in 71 Countries, 266 Payment Methods, 50+ Currencies.",
    optimization: "Optimize every stage of the payment flow and maximize your authorization rates.",
    ecological: "Established Open API and payment ecosystem to safeguard stable and <br />versatile connections.",
    compliance: "Certified and licensed in much of the United States, Europe, Japan, and multiple other Asian countries with an extensive global banking network.",
    fraud: "Providing high level fraud protection with real time transaction monitoring supported by data models and risk strategies.",
    client: "The dedicated customer success team <br />will work as your additional resources <br />for your global customer expansion."
  },
  globalDeploy: {
    title: "One Click for Globalization",
    desc: [
      "Principal member of the world’s 6 largest card schemes",
      "Cooperation with local card brand in France, Argentina, Brazil, such as Cartes Bancaires, Cabal, Tarjeta Naranja, Elo",
      "Supports local alternative payments in each of the countries PingPong services.",
      "Fully Supports Buy New, Pay Later capability"
    ],
  },
  eco: {
    title: "Ecosystem",
    subTitle: "Let payment be simple and easy",
  },
  bizScenario: {
    mainTitle: "Take payments online for your business",
    subTitle: "We offer a full spectrum of payment options to ensure you can provide customers with a seamless shopping experience",
    background: "Customer",
    challenge: "Customer's Problem",
    solution: "PingPong's Solution",
    onlineRetailers: {
      label: "e-Commerce",
      mainTitle: "某DTC独立站大卖",
      subTitle: "传统工贸企业转型跨境电商的典范",
      background: "A DTC E-commerce Website",
      challenge: [
        "A client with strong brand influence in the United States and Europe sought to improve the success rate of credit card payments and  improve their consumer conversion and repurchase rate.",
        "Further, the same client sought to reduce operating costs by finding a partner to provide both acquiring and supplier payment services."
      ],
      solution: [
        "Through PingPong's global payment routing, we offer a significant improvement of typical customers' credit card payment success rate",
        "Our local payment options substantially increase the conversion and customer repurchase rates.",
        "PingPong provides end to end funding solutions, including acquiring, supplier payment, and currency exchange as well as offering 24/7 support by phone.",
      ]
    },
    study: {
      label: "Education",
      mainTitle: "国内在线留学缴费领跑者",
      subTitle: "一站式服务平台，解决学费、申请费、宿舍费等跨境缴费难题",
      background: "Educational Payment Platform",
      challenge: [
        "Client wants to build an application for international students for ease of payment services that will support profit sharing and ease of distribution to local bank accounts.",
      ],
      solution: [
        "PingPong's product allows for card binding and payment through its platform. Further, it allows the customer to split the payment between the platform and merchants within the app while providing clarity into the distribution flow as well greatly improved delivery efficiency with multi-currency capability.",
      ]
    },
    takeOutFood: {
      label: "Food Delivery",
      mainTitle: "全球最大的中餐外卖平台之一",
      subTitle: "致力于推动海外华人餐饮行业的数字化进程",
      background: "Expanding food delivery service company that wants to increase visibility and access to other countries.",
      challenge: [
        "Limited resources with a need to adapt the customer's current checkout procedure to allow for local payment methods.",
      ],
      solution: [
        "PingPong provides a wide variety of locally available payment methods (depending on the country) and will always match with the client's development resources, need for customization, and speed of delivery.",
      ]
    },
    travel: {
      label: "Ride-Hailing",
      mainTitle: "出行行业独角兽",
      subTitle: "拓展国际业务，加速全球化进程",
      background: "Ride-Hailing company seeking international expansion to accelerate their  business and gain market exposure.",
      challenge: [
        "Company has had issues with KYB verification of overseas contractors/drivers as well as a need for local payment methods and professional experience in the domestic payment space.",
      ],
      solution: [
        "Provide KYB services including professional teams assist customers to complete offline, and also simplify the KYB process",
        "Provide local payment methods for Southeast Asian, European customers and overseas Chinese",
        "Powerful risk management for virtual goods, handling chargeback in accordance with high capture rate."
      ]
    }
  },
  footerBlock: {
    title: "Move to global acquiring",
    register: "Get Started",
  },
  product: {
    productTitle: "Select PingPong Checkout",
    productIntro:
      "You can use one PingPong Checkout account to easily manage the acquisition service of all your websites; And use one API to make transactions in more than 50 currencies.",
    productSubIntro:
      "You will have a more efficient acquiring experience on the basis of safety and humanity.",
    productIntroBtn: "Register Now",
    listLanTitle: "Improve Success Rate",
    listLanP1: "Support multiple development languages",
    listLanP2: "Complete payments without page forwarding",
    listLanP3: "Reduce the turnover rate",
    listMbTitle: "Optimize the Mobile Experience",
    listMbP1: "Leading Mobile SDK Technology",
    listMbP2: "Fully support for ApplePay and GooglePay",
    listMbP3: "Help improve the user experience",
  },
  serve: {
    serveTitle: "Products and Service",
    serveList1: "Anti-Fraud",
    serveList2: "Payment Gateway",
    serveList3: "Unified Settlement",
    specialListTitle: "Global Standard Compliant Payment System",
    specialListIntro1st:
      "One of the few domestic cross-border acquiring companies that have payment licenses in China、HongKong(China)、US、Europe and Japan",
    specialListIntro2nd: "Extensive global network of cooperative banks.",
    specialListIntro3rd:
      "Obtained the highest rating from an international authoritative third-party compliance assessment association for several consecutive years",
    specialRiskTitle: "International Leading Risk Solutions",
    specialRiskIntro1st:
      "Strong risk control and anti-fraud system to ensure the safety of payments",
    specialRiskIntro2nd: "3-D Secure",
    specialRiskIntro3rd: "PCI DSS 3.2 certification",
    specialSettlementTitle: "Thoughtful settlement methods",
    specialSettlementIntro1st: "Flexible deposit strategy",
    specialSettlementIntro2nd: "Diversified settlement methods",
    companyName: "Hangzhou PingPong Intellectual Technology Co, Ltd .",
  },
  pay: {
    payTitle: "Overseas Payment",
    paySubTitle:
      "One API can be connected to the mobile and PC terminal to accept payments ",
    paySubTitleSplit: "by multiple mainstream currencies and credit cards",
    payItem1st: "International credit card",
    payItem2nd: "Local payment",
    payItem3rd: "Mobile payment",
  },
  partner: {
    partnerTitle: "Cooperation Partners",
    faqTitle: "Q&A",
  },
  faq: [
    {
      id: 1,
      category: "Merchants docking",
      menu: [
        {
          id: 7,
          title: "Before the launch",
          question: [
            {
              q: "PingPong Checkout registration steps",
              a: [
                '1. Real-name Authentication: Click "Account Center" (upper right corner) → "Identity Verification"',
                '2. Add a payment account: Click "Account Center" (upper right corner)',
                '3. Add a website: click "Websites"',
                '4. There is no strong correlation between the second and third steps and the order is interchangeable.',
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      category: "Test section",
      menu: [
        {
          id: 8,
          title: "Shopify",
          question: [
            {
              q: "Shopify update, each payment service provider needs to complete the installation of the new version before July 31, 2022, whether it will affect the use",
              a: "This tip comes as Shopify is updating its payment platform. PingPong Checkout will inform you to install the new payment application in batches. The update is expected to be completed before June 30, 2022. After the update, payment service will not be affected, please wait patiently.We will communicate with you later and guide the switch. Thank you for your support.",
            },
            {
              q: "Test error for technical reason",
              a: [
                "1. Please confirm whether the test mode is cancelled. ",
                "2. Whether the mailing address is set",
              ],
            },
            {
              q: "After the new version is installed, the page card label cannot be displayed.",
              a: "After the shopify website is updated, the webpage card label will not be displayed, and the customer order will still be displayed normally.PingPong has communicated with Shopify for optimization",
            },
          ],
        },
        {
          id: 9,
          title: "Shoplazza",
          question: [
            {
              q: "How do shopkeepers install it?",
              a: 'Hello, you need to register PingPong Checkout background: https://checkout.pingpongx.com/, in the "system management" from the menu to obtain the relevant parameters, key setting 】 【 concrete shop ID, client ID, key is copied to the shop as the background.[Merchant ID is client ID, and account ID is accID]',
            },
          ],
        },
        {
          id: 10,
          title: "self-build",
          question: [
            {
              q: "The process of self-built station interconnection",
              a: "Technical personnel from both sides are required to participate in the early stage. After technology docking, complete sandbox environment test. Approval to the operation colleagues to complete the production configuration and testing.",
            },
          ],
        },
        {
          id: 11,
          title: "test",
          question: [
            {
              q: "Online payment test",
              a: "Hello, it is suggested to test by yourself or pay attention to the follow-up transaction situation;If pingpong is needed to help test, please provide the $1 test link.(Currently only V/M card test is supported. If local bank card payment or other card brands are involved, the operation cannot be tested.)",
            },
          ],
        },
      ],
    },
    {
      id: 3,
      category: "Order related",
      menu: [
        {
          id: 12,
          title: "Method of payment",
          question: [
            {
              q: "What payment methods does PingPong Checkout currently support?",
              a: "Currently supported card brands include: VISA, Mastercard, JCB, DinersClub, Discover, American Express (please contact sales manager if you need to add localized payment)",
            },
          ],
        },
        {
          id: 13,
          title: "Payment issue",
          question: [
            {
              q: "PingPong Checkout merchant background, order failure reason query path",
              a: "Transactions-- Transaction log -- enter the Purchase Transaction Id/Merchant Transaction Id -- click the blue transaction serial number to view the specific failure reason."
            },
            {
              q: "Do not honor",
              a: "Hello, due to transaction restrictions, credit card issuing bank distrust, or cross-border credit card transaction limit and other reasons, cardholders need to contact the credit card issuing bank or change the card for payment."
            },
            {
              q: "3D validation failed",
              a: "Hello, the cardholder failed to verify his fingerprint or face or SMS because of security problems, such as the possibility of swiping, when he paid this order.Please do not close the page for payment after the card holder enters the information, and make sure that the information is correct."
            },
            {
              q: "Transaction declined (invalid card/cardholder authentication verification failure/limit exceeded/expired card)",
              a: "Hello, as the card issuing bank returned invalid/cardholder authorization verification failure/payment amount exceeded/expired card, cardholders are advised to confirm the valid verification information of the card."
            },
            {
              q: "Transaction declined (High risk Transaction)",
              a: "Hello, this transaction is rejected because risk control has detected some risks."
            },
            {
              q: "Transaction declined(other reason)",
              a: "Hello, if such errors are reported, please feedback to the wechat group or the sales manager for help."
            },
            {
              q: "Received External system Response timeout",
              a: "Hello, the system has timed out to close the order. After the order is generated, the cardholder should complete the payment as soon as possible, otherwise the order will time out and fail."
            },
            {
              q: "How long after the refund can arrive in the account",
              a: "Refund time depends on the speed of the issuing bank, generally between 7 working days and 1 month, it is suggested that the card holder contact the issuing bank to confirm."
            },
            {
              q: "Refund failed",
              a: [
                "The failure of refund is as follows: ",
                "1.the cardholder has to initiate to refusal of payment for this order, so can't refund;",
                "2.The refund time has exceeded the bank limit (usually 180 days, some banks have different time); ",
                "3.If the card issuer is Russia, Ukraine and other sanctions countries, the refund will fail; ",
                `4. In addition to the above reasons, please provide the "PS" at the beginning of pay the order number to give to the group of operations, operations will follow and solve.`,
              ]
            },
          ],
        },
        {
          id: 14,
          title: "The order status",
          question: [
            {
              q: "If the transaction type is approved and the status is SUCCESS, why is there no settlement?",
              a: "The orders with transaction types of Approve and Reject are both the approval orders of risk orders, corresponding to transaction types of consumption-success and consumption-cancellation respectively, which are not included in settlement.When checking transactions and settling orders, only those orders with consumption as the transaction type can be used."
            },
            {
              q: "Orders to be reviewed",
              a: "It is usually processed within 24 hours."
            },
            {
              q: "Dishonor orders",
              a: "If there is a dishonor order, you can check it by email or find this transaction in [Chargeback Management] - [Order Dishonor Management] of PingPong Checkout background and appeal.It is recommended to contact and communicate with buyers first."
            },
            {
              q: "How to view risk orders in the system?",
              a: "Risk  - Risk Transaction Management, available in PingPong Checkout background"
            },
            {
              q: "After the customer placed the order, the order status was displayed as pending, pingpong, can't the transaction be found in the background?",
              a: "Pending orders indicate that the user does not initiate payment, but only requests to the checkout page."
            },
          ],
        }
      ],
    },
    {
      id: 4,
      category: "withdrawal",
      menu: [
        {
          id: 15,
          title: "Account Settings",
          question: [
            {
              q: "How to add VA account",
              a: "Hello, you can directly add VA in PingPong Checkout background -- upper right corner [Account Center] -- [Withdrawal Account]; Please refer to [VA Withdrawal manuals]"
            },
            {
              q: "How to add a Bank account",
              a: "Generally need to public accounts, support to receive US dollars."
            }
          ]
        },
        {
          id: 16,
          title: "Account audit",
          question: [
            {
              q: "Time limit for checking withdrawal account",
              a: "VA withdrawal account, no manual audit;To add other bank accounts, contact the sales manager to report the approval of risk control."
            }
          ]
        },
        {
          id: 17,
          title: "Withdraw time",
          question: [
            {
              q: "How long will it take to receive the account after initiating withdrawal",
              a: "Withdrawal generally takes 1-3 working days to arrive in the account, such as withdrawal to VA account can arrive in the account on the same day."
            }
          ]
        },
        {
          id: 18,
          title: "Lack of credit",
          question: [
            {
              q: "Withdraw VA, the withdrawal amount to pingpong main station is not enough.",
              a: [
                `1. Please bind the logistics plug-in in time and add a virtual account (currency: USD) to PingPong Checkout background withdrawal account;`,
                `2. Order management - Query orders with unuploaded status - At present, the judgment logic of the uploaded status is that the merchant name and logistics bill number must be filled in to display the green uploaded status. If the system does not capture the merchant name, it must be manually filled in.`,
              ]
            }
          ]
        }
      ],
    },
    {
      id: 5,
      category: "Rate/quotation",
      menu: [
        {
          id: 19,
          title: "Fee",
          question: [
            {
              q: "How to charge the commission fee?",
              a: "Hello, the handling fee is calculated according to the fixed fee plus proportion. For details, please refer to the contract rate or contact the sales manager"
            },
            {
              q: "How to charge for non-payment?",
              a: "Hello, please confirm the refusal charge in the contract. If you have any questions about specific orders, please provide us with the transaction serial number."
            },
            {
              q: "Withdrawal commission deduction rules?",
              a: "Withdrawal charges (please refer to the contract) are deducted from the withdrawal amount initiated by the merchant.When merchants input the withdrawal amount, they will prompt the handling fee amount and the actual amount received."
            },
            {
              q: "What is revolving margin?",
              a: "Revolving margin refers to the total margin charged at 10% of the amount of each transaction, which is released after 180 days and counted into the withdrawal amount (please refer to the contract for details)."
            },
            {
              q: "Refusal to pay early warning fees",
              a: "Hello, the mechanism of dishonor warning is that when our system recognizes that fraudulent dishonor is about to be launched, the order will be refunded. After the refund, the order will not be turned into a dishonor order, but a refund order, so as to reduce your dishonor rate.A non-payment early warning fee is charged for this operation."
            },
          ]
        },
        {
          id: 20,
          title: "Statements",
          question: [
            {
              q: "Account checking",
              a: "Hello, Statement in the background -- the downloaded monthly fund statement shall prevail. Please refer to this dimension for account checking.(If there is any difference between the feedback statement details and the background of the website building tool, please provide the difference order list, and we will feedback the technical positioning problem)"
            },
            {
              q: "The refusal of payment in the statement is inconsistent with other statement cycles, why?",
              a: "Hello, the statement of transaction and refund is in accordance with the settlement cycle of the contract. If dispayment occurs, it will be accounted into the account directly."
            }
          ]
        },
        {
          id: 21,
          title: "Settlement",
          question: [
            {
              q: "How to settle according to the original currency?",
              a: "Hello, please contact the corresponding sales."
            },
            {
              q: "When will the settlement be made?",
              a: "Please refer to the settlement period in the contract. In case of domestic holidays or channel holidays, the settlement will be postponed."
            }
          ]
        }
      ],
    },
    {
      id: 6,
      category: "logistics",
      menu: [
        {
          id: 22,
          title: "Logistics plug-in",
          question: [
            {
              q: "How to bind?",
              a: [
                "For Shopify/Shoplazza stores, they can automatically obtain the logistic number as follows: ",
                "1) Enter PingPong Checkout site management;",
                `2) Click the ellipsis on the right and select "Logistics Binding";`,
                "3) Fill in the domain name of shopify background management account;",
                "4) After logging in to shopify, follow the instructions to install the PingPong Checkout application.",
              ]
            }
          ]
        }
      ],
    },
  ],
};

export default en;
